const SIDEBAR_WIDTH = "60px";

export const SIDEBAR_EXPANDED_WIDTH = "253px";

export default SIDEBAR_WIDTH;
